import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MiniGuideDataService } from './mini-guide-data.service';

@Injectable({
  providedIn: 'root'
})
export class MiniGuidanceService {

  private guide: Subject<boolean> = new Subject<boolean>();
  public onNextGuideReady = this.guide.asObservable();

  private guideClose: Subject<void> = new Subject();
  public onForceClose = this.guideClose.asObservable();

  constructor() { }

  closeGuide(isNext: boolean) 
  {
    this.guide.next(isNext);
  }

  getGuides(id: string)
  {
    return MiniGuideDataService.data[id];
  }

  forceCloseCurrentGuide()
  {
    this.guideClose.next();
  }
}
